module.exports = __webpack_public_path__ + "img/tuijianchapin.87f599af.png";